import apiService from './apiService'

export const requestListFulfillmentOperators = (queryParams) => {
  return apiService.get(URIS.fulfillmentOperators, {
    params: {
      page: queryParams?.page ?? 1,
      item_per_page: 10,
      word: queryParams?.word,
    },
  })
}

export const requestCreateFulfillmentOperator = (data) => {
  return apiService.post(URIS.fulfillmentOperators, data)
}

export const requestUpdateFulfillmentOperatorStatus = (operatorId, status) => {
  return apiService.patch(`${URIS.fulfillmentOperators}/${operatorId}`, {
    status,
  })
}

const URIS = {
  fulfillmentOperators: '/v1/admin/fulfillment-operators',
}
